// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
    width: 100%;
}

.new-container {
    width: 100%;
    margin: 0;
}

.new-container .title {
    margin: 0 auto 10px;
}

.new-container form {
    background-color: var(--color-bg-dark);
    color: var(--color-text-white);
    width: 100%;
    border: 2px solid var(--color-primary);
    padding: var(--spacing-8) !important;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-wrap: wrap;
}

.new-container form > div {
    width: 48%;
}

.new-container form label {
    margin-bottom: 3px;
    font-size: small;
    color: #ffffff !important; /* Color blanco para mejor contraste */
}

.new-container form .form-label {
    color: #ffffff !important;
    font-weight: 500;
}

.new-container form .form-check-label {
    color: #ffffff !important;
}

.new-container .imagenes {
    width: 100% !important;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-wrap: wrap;
}

.new-container .imagenes > div {
    width: 49%;
}

.new-container .imgs {
    max-width: 50%;
    max-height: 200px;
}

.new-container .toBlockchain {
    padding: var(--spacing-2) var(--spacing-8);
    border: 1px solid var(--color-border-medium);
}

.new-container .docsPDF {
    display: block;
    width: 96%;
    margin: var(--spacing-2) 0 0;
    color: var(--color-text-white);
    text-decoration: none;
}

.new-container .deleteProyect {
    display: block;
    margin: 0 auto;
    padding: var(--spacing-4);
    width: 100%;
}

/* Estilo para botón rojo habilitado - debe verse rojo siempre */
.new-container .deleteProyect.btn-danger:not(:disabled),
.new-container .deleteProyect.btn-danger:not([disabled]) {
    background-color: #dc3545 !important;
    border-color: #dc3545 !important;
    color: #ffffff !important;
    font-weight: 500 !important;
}

/* Hover del botón rojo habilitado - más fuerte */
.new-container .deleteProyect.btn-danger:not(:disabled):hover,
.new-container .deleteProyect.btn-danger:not([disabled]):hover {
    background-color: #c82333 !important;
    border-color: #bd2130 !important;
    color: #ffffff !important;
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(220, 53, 69, 0.4) !important;
}

/* Estilo para botón disabled - debe verse rojo siempre */
.new-container .deleteProyect.btn-danger:disabled,
.new-container .deleteProyect.btn-danger[disabled] {
    background-color: #dc3545 !important;
    border-color: #dc3545 !important;
    color: #ffffff !important;
    opacity: 0.65 !important;
    cursor: not-allowed !important;
}

.new-container .deleteProyect.btn-danger:disabled:hover,
.new-container .deleteProyect.btn-danger[disabled]:hover {
    background-color: #dc3545 !important;
    border-color: #dc3545 !important;
    opacity: 0.65 !important;
}

.errorInput {
    background-color: var(--color-danger);
    opacity: 0.2;
}

.blockedField {
    background-color: var(--color-bg-secondary) !important;
    color: var(--color-text-muted) !important;
    cursor: not-allowed !important;
    opacity: 0.7;
}

.blockedField:focus {
    box-shadow: none !important;
    border-color: var(--color-border-medium) !important;
}

.blockedFieldLabel {
    color: var(--color-text-muted) !important;
    font-style: italic;
}

.blockedFieldLabel::after {
    content: " (Bloqueado)";
    color: var(--color-danger);
    font-size: var(--font-size-xs);
    font-weight: var(--font-weight-normal);
}

/* Estilos para el sistema de viviendas múltiples */
.vivienda-container {
    background-color: rgba(255, 255, 255, 0.05);
    border: 1px solid var(--color-primary) !important;
    transition: all 0.3s ease;
}

.vivienda-container:hover {
    background-color: rgba(255, 255, 255, 0.08);
    border-color: var(--color-primary-light) !important;
}

.vivienda-container .btn-danger {
    background-color: var(--color-danger);
    border-color: var(--color-danger);
    color: var(--color-text-white);
    padding: var(--spacing-2) var(--spacing-3);
    font-size: var(--font-size-sm);
    border-radius: var(--spacing-1);
    transition: all 0.15s ease-in-out;
}

.vivienda-container .btn-danger:hover {
    background-color: var(--color-danger-hover);
    border-color: var(--color-danger-hover);
    transform: scale(1.05);
}

.vivienda-container .btn-outline-primary {
    color: var(--color-primary);
    border-color: var(--color-primary);
    background-color: transparent;
}

.vivienda-container .btn-outline-primary:hover {
    color: var(--color-text-white);
    background-color: var(--color-primary);
    border-color: var(--color-primary);
}

.vivienda-container .btn-outline-secondary:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    background-color: transparent;
    border-color: #6c757d;
    color: #6c757d;
}

.vivienda-container .btn-outline-secondary:disabled i {
    color: #6c757d;
}

@media (max-width: 500px) {
    .new-container .title {
        margin: 15px auto 6px;
    }

    .new-container form {
        padding: 8px !important;
    }

    .new-container form > div {
        width: 100%;
    }

    .new-container .imagenes > div {
        width: 100%;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/components/proyect-set-data/proyect-set-data/proyect-set-data.component.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,SAAS;AACb;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,sCAAsC;IACtC,8BAA8B;IAC9B,WAAW;IACX,sCAAsC;IACtC,oCAAoC;IACpC,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB,EAAE,sCAAsC;AACrE;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,0CAA0C;IAC1C,4CAA4C;AAChD;;AAEA;IACI,cAAc;IACd,UAAU;IACV,4BAA4B;IAC5B,8BAA8B;IAC9B,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,yBAAyB;IACzB,WAAW;AACf;;AAEA,gEAAgE;AAChE;;IAEI,oCAAoC;IACpC,gCAAgC;IAChC,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA,iDAAiD;AACjD;;IAEI,oCAAoC;IACpC,gCAAgC;IAChC,yBAAyB;IACzB,2BAA2B;IAC3B,uDAAuD;AAC3D;;AAEA,yDAAyD;AACzD;;IAEI,oCAAoC;IACpC,gCAAgC;IAChC,yBAAyB;IACzB,wBAAwB;IACxB,8BAA8B;AAClC;;AAEA;;IAEI,oCAAoC;IACpC,gCAAgC;IAChC,wBAAwB;AAC5B;;AAEA;IACI,qCAAqC;IACrC,YAAY;AAChB;;AAEA;IACI,sDAAsD;IACtD,yCAAyC;IACzC,8BAA8B;IAC9B,YAAY;AAChB;;AAEA;IACI,2BAA2B;IAC3B,mDAAmD;AACvD;;AAEA;IACI,yCAAyC;IACzC,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,0BAA0B;IAC1B,8BAA8B;IAC9B,sCAAsC;AAC1C;;AAEA,mDAAmD;AACnD;IACI,2CAA2C;IAC3C,iDAAiD;IACjD,yBAAyB;AAC7B;;AAEA;IACI,2CAA2C;IAC3C,mDAAmD;AACvD;;AAEA;IACI,qCAAqC;IACrC,iCAAiC;IACjC,8BAA8B;IAC9B,0CAA0C;IAC1C,8BAA8B;IAC9B,+BAA+B;IAC/B,iCAAiC;AACrC;;AAEA;IACI,2CAA2C;IAC3C,uCAAuC;IACvC,sBAAsB;AAC1B;;AAEA;IACI,2BAA2B;IAC3B,kCAAkC;IAClC,6BAA6B;AACjC;;AAEA;IACI,8BAA8B;IAC9B,sCAAsC;IACtC,kCAAkC;AACtC;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,6BAA6B;IAC7B,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI;QACI,qBAAqB;IACzB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;AACJ","sourcesContent":[":host {\n    width: 100%;\n}\n\n.new-container {\n    width: 100%;\n    margin: 0;\n}\n\n.new-container .title {\n    margin: 0 auto 10px;\n}\n\n.new-container form {\n    background-color: var(--color-bg-dark);\n    color: var(--color-text-white);\n    width: 100%;\n    border: 2px solid var(--color-primary);\n    padding: var(--spacing-8) !important;\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    flex-wrap: wrap;\n}\n\n.new-container form > div {\n    width: 48%;\n}\n\n.new-container form label {\n    margin-bottom: 3px;\n    font-size: small;\n    color: #ffffff !important; /* Color blanco para mejor contraste */\n}\n\n.new-container form .form-label {\n    color: #ffffff !important;\n    font-weight: 500;\n}\n\n.new-container form .form-check-label {\n    color: #ffffff !important;\n}\n\n.new-container .imagenes {\n    width: 100% !important;\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    flex-wrap: wrap;\n}\n\n.new-container .imagenes > div {\n    width: 49%;\n}\n\n.new-container .imgs {\n    max-width: 50%;\n    max-height: 200px;\n}\n\n.new-container .toBlockchain {\n    padding: var(--spacing-2) var(--spacing-8);\n    border: 1px solid var(--color-border-medium);\n}\n\n.new-container .docsPDF {\n    display: block;\n    width: 96%;\n    margin: var(--spacing-2) 0 0;\n    color: var(--color-text-white);\n    text-decoration: none;\n}\n\n.new-container .deleteProyect {\n    display: block;\n    margin: 0 auto;\n    padding: var(--spacing-4);\n    width: 100%;\n}\n\n/* Estilo para botón rojo habilitado - debe verse rojo siempre */\n.new-container .deleteProyect.btn-danger:not(:disabled),\n.new-container .deleteProyect.btn-danger:not([disabled]) {\n    background-color: #dc3545 !important;\n    border-color: #dc3545 !important;\n    color: #ffffff !important;\n    font-weight: 500 !important;\n}\n\n/* Hover del botón rojo habilitado - más fuerte */\n.new-container .deleteProyect.btn-danger:not(:disabled):hover,\n.new-container .deleteProyect.btn-danger:not([disabled]):hover {\n    background-color: #c82333 !important;\n    border-color: #bd2130 !important;\n    color: #ffffff !important;\n    transform: translateY(-1px);\n    box-shadow: 0 4px 8px rgba(220, 53, 69, 0.4) !important;\n}\n\n/* Estilo para botón disabled - debe verse rojo siempre */\n.new-container .deleteProyect.btn-danger:disabled,\n.new-container .deleteProyect.btn-danger[disabled] {\n    background-color: #dc3545 !important;\n    border-color: #dc3545 !important;\n    color: #ffffff !important;\n    opacity: 0.65 !important;\n    cursor: not-allowed !important;\n}\n\n.new-container .deleteProyect.btn-danger:disabled:hover,\n.new-container .deleteProyect.btn-danger[disabled]:hover {\n    background-color: #dc3545 !important;\n    border-color: #dc3545 !important;\n    opacity: 0.65 !important;\n}\n\n.errorInput {\n    background-color: var(--color-danger);\n    opacity: 0.2;\n}\n\n.blockedField {\n    background-color: var(--color-bg-secondary) !important;\n    color: var(--color-text-muted) !important;\n    cursor: not-allowed !important;\n    opacity: 0.7;\n}\n\n.blockedField:focus {\n    box-shadow: none !important;\n    border-color: var(--color-border-medium) !important;\n}\n\n.blockedFieldLabel {\n    color: var(--color-text-muted) !important;\n    font-style: italic;\n}\n\n.blockedFieldLabel::after {\n    content: \" (Bloqueado)\";\n    color: var(--color-danger);\n    font-size: var(--font-size-xs);\n    font-weight: var(--font-weight-normal);\n}\n\n/* Estilos para el sistema de viviendas múltiples */\n.vivienda-container {\n    background-color: rgba(255, 255, 255, 0.05);\n    border: 1px solid var(--color-primary) !important;\n    transition: all 0.3s ease;\n}\n\n.vivienda-container:hover {\n    background-color: rgba(255, 255, 255, 0.08);\n    border-color: var(--color-primary-light) !important;\n}\n\n.vivienda-container .btn-danger {\n    background-color: var(--color-danger);\n    border-color: var(--color-danger);\n    color: var(--color-text-white);\n    padding: var(--spacing-2) var(--spacing-3);\n    font-size: var(--font-size-sm);\n    border-radius: var(--spacing-1);\n    transition: all 0.15s ease-in-out;\n}\n\n.vivienda-container .btn-danger:hover {\n    background-color: var(--color-danger-hover);\n    border-color: var(--color-danger-hover);\n    transform: scale(1.05);\n}\n\n.vivienda-container .btn-outline-primary {\n    color: var(--color-primary);\n    border-color: var(--color-primary);\n    background-color: transparent;\n}\n\n.vivienda-container .btn-outline-primary:hover {\n    color: var(--color-text-white);\n    background-color: var(--color-primary);\n    border-color: var(--color-primary);\n}\n\n.vivienda-container .btn-outline-secondary:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n    background-color: transparent;\n    border-color: #6c757d;\n    color: #6c757d;\n}\n\n.vivienda-container .btn-outline-secondary:disabled i {\n    color: #6c757d;\n}\n\n@media (max-width: 500px) {\n    .new-container .title {\n        margin: 15px auto 6px;\n    }\n\n    .new-container form {\n        padding: 8px !important;\n    }\n\n    .new-container form > div {\n        width: 100%;\n    }\n\n    .new-container .imagenes > div {\n        width: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
